import React, { useState, useEffect } from 'react';
import { Chart } from 'primereact/chart';

export default function CSCOLineChart(lProps) {
    const [mChartData, setChartData] = useState({});
    const [mChartOptions, setChartOptions] = useState({});

    useEffect(() => {
        const lDocumentStyle = getComputedStyle(document.documentElement);
        const lTextColor = lDocumentStyle.getPropertyValue('--text-color');
        const lSurfaceBorder = lDocumentStyle.getPropertyValue('--surface-border');
        let lChartData = {};

        let lData = lProps.pDataCollection || lProps.pData;
        if (lData && ((lProps.pChartData && lProps.pChartData.chart_data_field_) || (lProps.pReportChartProperties))) {
            if (lProps.pChartData && lProps.pChartData.chart_var_field_) {
                lChartData.labels = [];
                lChartData.datasets = [];
                if (lProps.pChartData.hasOwnProperty('chart_data_type_') && (lProps.pChartData.chart_data_type_ === 'VARIABLE')) {
                    let lChartDataField = lProps.pChartData.chart_data_field_[0];
                    let lChartLabelDataMap = {};
                    for (let lInd = 0; lInd < lData.length; lInd++) {
                        let lObj = lData[lInd];
                        let lDataLabel = lObj[lProps.pChartData.chart_data_label_];
                        let lData1 = lChartLabelDataMap[lDataLabel];
                        if (!lData1) {
                            lData1 = {};
                            lChartLabelDataMap[lDataLabel] = lData1;
                            lData1.data = [];
                        }
                        if (!lChartData.labels.includes(lObj[lProps.pChartData.chart_var_field_])) {
                            lChartData.labels.push(lObj[lProps.pChartData.chart_var_field_]);
                        }
                        lData1.data.push(lObj[lChartDataField]);
                    }

                    let lKeys = Object.keys(lChartLabelDataMap);
                    for (let lKeyInd = 0; lKeyInd < lKeys.length; lKeyInd++) {
                        let lDataObj = {}
                        lDataObj.label = lKeys[lKeyInd];
                        lDataObj.data = (lChartLabelDataMap[lKeys[lKeyInd]]).data;
                        lChartData.datasets.push(lDataObj);
                    }
                }
                else {
                    for (let lDataInd = 0; lDataInd < lProps.pChartData.chart_data_field_.length; lDataInd++) {
                        let lChartDataField = lProps.pChartData.chart_data_field_[lDataInd];
                        let lChartDataLabel = lProps.pChartData.chart_data_label_[lDataInd];
                        let lDataObj = {}
                        lDataObj.label = lChartDataLabel;
                        lDataObj.data = [];
                        for (let lInd = 0; lInd < lData.length; lInd++) {
                            let lObj = lData[lInd];
                            lDataObj.data.push(lObj[lChartDataField]);
                            if (lDataInd === 0) {
                                lChartData.labels.push(lObj[lProps.pChartData.chart_var_field_]);
                            }
                        }
                        lChartData.datasets.push(lDataObj);
                    }
                }
            }
            else if (lProps.pReportChartProperties) {
                let lReportProps = lProps.pReportChartProperties;

                let lChartIdList = lReportProps.filter((lObj) => (lObj.property_name_ === 'chart_id_'));
                if (lChartIdList && lChartIdList.length > 0) {
                    lChartData.labels = [];
                    lChartData.datasets = [];

                    for (let lChartIdInd = 0; lChartIdInd < lChartIdList.length; lChartIdInd++) {
                        let lChartDataMap = lReportProps.filter((lObj) => (lObj.parent_ref_id_ === lChartIdList[lChartIdInd].id_));
                        let lChartDataVarField = null;
                        let lChartDataField = null;
                        let lChartDataLabel = null;
                        for (let lInd = 0; lInd < lChartDataMap.length; lInd++) {
                            if (lChartDataMap[lInd].property_name_ === 'chart_var_field_') {
                                lChartDataVarField = lChartDataMap[lInd].value_;
                            }

                            if (lChartDataMap[lInd].property_name_ === 'chart_data_field_') {
                                lChartDataField = lChartDataMap[lInd].value_;
                            }

                            if (lChartDataMap[lInd].property_name_ === 'chart_data_label_') {
                                lChartDataLabel = lChartDataMap[lInd].value_;
                            }
                        }

                        let lDataObj = {};
                        lDataObj.label = lChartDataLabel;
                        lDataObj.data = [];
                        for (let lDataInd = 0; lDataInd < lData.length; lDataInd++) {
                            let lObj = lData[lDataInd];

                            if (lChartDataVarField) {
                                if (lChartData.labels && (!lChartData.labels.includes(lObj[lChartDataVarField]))) {
                                    lChartData.labels.push(lObj[lChartDataVarField]);
                                }
                                else if (!lChartData.labels) {
                                    lChartData.labels = [];
                                    lChartData.labels.push(lObj[lChartDataVarField]);
                                }
                            }

                            lDataObj.data.push(lObj[lChartDataField]);
                        }

                        lChartData.datasets.push(lDataObj);
                    }
                }
                else {
                    let lChartDataVarField = null;
                    let lChartDataField = [];
                    let lChartDataLabel = [];
                    for (let lInd = 0; lInd < lReportProps.length; lInd++) {
                        if (lReportProps[lInd].property_name_ === 'chart_var_field_') {
                            lChartDataVarField = lReportProps[lInd].value_;
                        }

                        if (lReportProps[lInd].property_name_ === 'chart_data_field_') {
                            lChartDataField.push(lReportProps[lInd].value_);
                        }

                        if (lReportProps[lInd].property_name_ === 'chart_data_label_') {
                            lChartDataLabel.push(lReportProps[lInd].value_);
                        }
                    }

                    if (lChartDataField && lChartDataField.length > 0 && lChartDataLabel && lChartDataLabel.length > 0) {
                        lChartData.labels = [];
                        lChartData.datasets = [];

                        for (let lDataInd = 0; lDataInd < lChartDataField.length; lDataInd++) {
                            let lDataField = lChartDataField[lDataInd];
                            let lDataLabel = lChartDataLabel[lDataInd];

                            let lDataObj = {};
                            lDataObj.label = lDataLabel;
                            lDataObj.data = [];
                            for (let lInd = 0; lInd < lData.length; lInd++) {
                                let lObj = lData[lInd];
                                lDataObj.data.push(lObj[lDataField]);

                                if (lDataInd === 0) {
                                    lChartData.labels.push(lObj[lChartDataVarField]);
                                }
                            }

                            lChartData.datasets.push(lDataObj);
                        }
                    }
                }
            }
        }

        const lOptions = {
            maintainAspectRatio: false,
            aspectRatio: 0.8,
            plugins: {
                legend: {
                    labels: {
                        fontColor: lTextColor
                    }
                }
            },
            scales: {
                x: {
                    ticks: {
                        font: {
                            weight: 600
                        }
                    },
                    grid: {
                        display: true,
                        drawBorder: true
                    },
                },
                y: {
                    grid: {
                        color: lSurfaceBorder,
                        drawBorder: false
                    }
                }
            }
        };

        setChartData(lChartData);
        setChartOptions(lOptions);
    }, [lProps.pDataCollection, lProps.pData, lProps.pChartData, lProps.pReportChartProperties]);

    return (
        <Chart
            type="line"
            data={mChartData}
            options={mChartOptions}
            className="p-2"
        />
    );
}
